<template>
  <div>
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" :model="conditions">
        <el-form-item>
          <el-input v-model="conditions.goodsName" placeholder="商品名称" clearable />
        </el-form-item>
        <el-form-item>
          <el-select v-model="conditions.state" placeholder="状态" clearable style="width: 140px">
            <el-option label="上架" value="1001" />
            <el-option label="下架" value="2002" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="queryList">查询</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增商品</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header">
        <span>兑换商品</span>
      </div>
      <el-table :data="goodsList" border style="width: 100%">
        <el-table-column prop="goodsId" label="商品ID" align="center" width="160" />
        <el-table-column prop="goodsName" label="商品名称" align="center" min-width="120" />
        <el-table-column label="商品图片" align="center" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.goodsImg"
              :src="scope.row.goodsImg"
              :preview-src-list="[scope.row.goodsImg]"
              style="width: 50px; height: 50px"
              fit="cover" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="pointsPrice" label="所需积分" align="center" width="100" />
        <el-table-column prop="referencePrice" label="参考价(元)" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.referencePrice != null && scope.row.referencePrice !== '' ? scope.row.referencePrice : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="stock" label="库存" align="center" width="80" />
        <el-table-column prop="soldCount" label="已兑换" align="center" width="80" />
        <el-table-column prop="sort" label="排序" align="center" width="80" />
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            {{ getStateName(scope.row.state) }}
          </template>
        </el-table-column>
        <el-table-column label="商品详情" align="center" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatRemarkPreview(scope.row.remark) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="margin-top-sm"
        :current-page="conditions.page"
        :page-size="conditions.row"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handlePageChange" />
    </el-card>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="860px"
      top="5vh"
      @close="resetForm">
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <el-form-item label="商品名称" prop="goodsName">
          <el-input v-model="formData.goodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="商品图片">
          <upload-image-url ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleImageUpload" />
        </el-form-item>
        <el-form-item label="所需积分" prop="pointsPrice">
          <el-input v-model="formData.pointsPrice" placeholder="兑换所需积分" />
        </el-form-item>
        <el-form-item label="参考价">
          <el-input v-model="formData.referencePrice" placeholder="选填，单位：元" />
        </el-form-item>
        <el-form-item label="库存" prop="stock">
          <el-input v-model="formData.stock" placeholder="库存数量" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="formData.sort" placeholder="越大越靠前" />
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-radio-group v-model="formData.state">
            <el-radio label="1001">上架</el-radio>
            <el-radio label="2002">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品详情">
          <rich-text-editor
            ref="richTextEditor"
            @input="handleRemarkChange" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/system/UploadImageUrl'
import RichTextEditor from '@/components/system/RichTextEditor.vue'
import {
  listPointsExchangeGoods,
  savePointsExchangeGoods,
  updatePointsExchangeGoods,
  deletePointsExchangeGoods
} from '@/api/admin/pointsCheckIn/pointsCheckInApi'

export default {
  name: 'PointsExchangeGoodsManage',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      goodsList: [],
      total: 0,
      conditions: {
        goodsName: '',
        state: '',
        page: 1,
        row: 10
      },
      dialogVisible: false,
      dialogMode: 'add',
      formData: {
        goodsId: '',
        goodsName: '',
        goodsImg: '',
        pointsPrice: '',
        referencePrice: '',
        stock: '',
        sort: '0',
        state: '1001',
        remark: ''
      },
      rules: {
        goodsName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        pointsPrice: [{ required: true, message: '请输入所需积分', trigger: 'blur' }],
        stock: [{ required: true, message: '请输入库存', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.dialogMode === 'add' ? '新增兑换商品' : '编辑兑换商品'
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    getStateName(state) {
      if (state === '1001') {
        return '上架'
      }
      if (state === '2002') {
        return '下架'
      }
      return state || '-'
    },
    formatRemarkPreview(remark) {
      if (!remark) {
        return '-'
      }
      const text = remark.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim()
      if (!text) {
        return '[图文详情]'
      }
      return text.length > 40 ? text.substring(0, 40) + '...' : text
    },
    async loadList() {
      try {
        const res = await listPointsExchangeGoods(this.conditions)
        this.goodsList = res.data || []
        this.total = res.records || 0
      } catch (error) {
        console.error('获取兑换商品列表失败:', error)
      }
    },
    queryList() {
      this.conditions.page = 1
      this.loadList()
    },
    handlePageChange(page) {
      this.conditions.page = page
      this.loadList()
    },
    initRichTextEditor(content) {
      this.$nextTick(() => {
        if (!this.$refs.richTextEditor) {
          return
        }
        if (content) {
          this.$refs.richTextEditor.setContent(content)
        } else {
          this.$refs.richTextEditor.clear()
        }
      })
    },
    openAddDialog() {
      this.dialogMode = 'add'
      this.resetForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.uploadImage && this.$refs.uploadImage.clearImages()
        this.initRichTextEditor('')
      })
    },
    openEditDialog(row) {
      this.dialogMode = 'edit'
      this.formData = {
        goodsId: row.goodsId,
        goodsName: row.goodsName,
        goodsImg: row.goodsImg || '',
        pointsPrice: row.pointsPrice,
        referencePrice: row.referencePrice || '',
        stock: row.stock,
        sort: row.sort || '0',
        state: row.state,
        remark: row.remark || ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.uploadImage) {
          this.$refs.uploadImage.clearImages()
          if (row.goodsImg) {
            this.$refs.uploadImage.setImages([row.goodsImg])
          }
        }
        this.initRichTextEditor(row.remark || '')
      })
    },
    resetForm() {
      this.formData = {
        goodsId: '',
        goodsName: '',
        goodsImg: '',
        pointsPrice: '',
        referencePrice: '',
        stock: '',
        sort: '0',
        state: '1001',
        remark: ''
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      if (this.$refs.richTextEditor) {
        this.$refs.richTextEditor.clear()
      }
    },
    handleImageUpload(photos) {
      this.formData.goodsImg = photos && photos.length > 0 ? photos[0] : ''
    },
    handleRemarkChange(html) {
      this.formData.remark = html
    },
    submitForm() {
      if (this.$refs.richTextEditor) {
        this.formData.remark = this.$refs.richTextEditor.getContent()
      }
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          const api = this.dialogMode === 'add' ? savePointsExchangeGoods : updatePointsExchangeGoods
          const res = await api(this.formData)
          if (res.code !== 0) {
            this.$message.error(res.msg || '保存失败')
            return
          }
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.loadList()
        } catch (error) {
          console.error('保存兑换商品失败:', error)
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该兑换商品吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deletePointsExchangeGoods({ goodsId: row.goodsId })
          if (res.code !== 0) {
            this.$message.error(res.msg || '删除失败')
            return
          }
          this.$message.success('删除成功')
          this.loadList()
        } catch (error) {
          console.error('删除兑换商品失败:', error)
        }
      }).catch(() => {})
    }
  }
}
</script>
